<p>
  files works!
</p>



// WEBPACK FOOTER //
// ./src/app/platform/customer/files/files.component.html